import { render, staticRenderFns } from "./Macrocabinet.vue?vue&type=template&id=4fdbeb45&"
import script from "./Macrocabinet.vue?vue&type=script&lang=js&"
export * from "./Macrocabinet.vue?vue&type=script&lang=js&"
import style0 from "./Macrocabinet.vue?vue&type=style&index=0&id=4fdbeb45&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports